import { render, staticRenderFns } from "./NavigatorSubMenu.vue?vue&type=template&id=03472ba6"
import script from "./NavigatorSubMenu.vue?vue&type=script&lang=js"
export * from "./NavigatorSubMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigatorSubMenu.vue?vue&type=style&index=0&id=03472ba6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports